import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "textBox" }
const _hoisted_2 = { class: "textBoxLeft" }
const _hoisted_3 = { class: "textBoxRight" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["value"]

import { ref, onMounted,getCurrentInstance, watch } from 'vue'
import { languageSound } from '@/components/common/publicTxt.ts'
import translationApi from '@/api/common/translate.ts'

export default /*@__PURE__*/_defineComponent({
  __name: 'textEdit',
  emits: ['reListData'],
  setup(__props, { emit: __emit }) {

const emit = __emit
// 输入文字
const textarea=ref('')
const historyTxt=ref('')
const isdisabled=ref(true)
// 选中
const language=ref('0')
// 
watch(textarea,(n,o)=>{
    console.log(n)
    if(n.length==0){
        language.value='0'
        isdisabled.value=true
    }else{
        isdisabled.value=false
    }
})
const changeLanguage=()=>{
    console.log(language.value)
    if(language.value=='0'){
        textarea.value=historyTxt.value
    }else{
        translationApi.getTranstlate(textarea.value,language.value).then(res=>{
            console.log(res)
            textarea.value=res.msg
            emit('reListData',[textarea.value,language.value])
        })
    }
   
}
const changeTxt=()=>{
    historyTxt.value=textarea.value
    emit('reListData',[historyTxt.value,language.value])
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: textarea.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textarea).value = $event)),
        maxlength: "5000",
        style: {"height":"100%"},
        placeholder: "请输入要生成的文字内容",
        "show-word-limit": "",
        type: "textarea",
        resize: "none",
        onChange: changeTxt
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((language).value = $event)),
        class: "toselect",
        disabled: isdisabled.value,
        onChange: changeLanguage
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageSound), (item, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: item.value,
            key: index
          }, _toDisplayString(item.text), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_4), [
        [_vModelSelect, language.value]
      ])
    ])
  ]))
}
}

})